import { IconStorage } from "@app/shared/icons/interfaces";

export const chevronDown: IconStorage = {
  svgCode: () => ([
    "M6 9L12 15L18 9",
  ]),
};

export const chevronLeft: IconStorage = {
  svgCode: () => ([
    "M15 18L9 12L15 6",
  ]),
};

export const chevronRight: IconStorage = {
  svgCode: () => ([
    "M9 18L15 12L9 6",
  ]),
};

export const chevronRightDouble: IconStorage = {
  svgCode: () => ([
    "M6 17L11 12L6 7M13 17L18 12L13 7",
  ]),
};

export const chevronUp: IconStorage = {
  svgCode: () => ([
    "M18 15L12 9L6 15",
  ]),
};

export const chevronUpDouble: IconStorage = {
  svgCode: () => ([
    "M17 18L12 13L7 18M17 11L12 6L7 11",
  ]),
};
